import Request from './request'
import addKeyLocalStorage from '../helper/localStorage'

export default class appUserService {
  static async getUserInfo(data) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: '/AppUsers/user/getUserInfo',
        data: data
      }).then((result = {}) => {
        const { statusCode, data } = result
        if (statusCode === 200) {
          return resolve({ isSuccess: true, data })
        } else {
          return resolve({ isSuccess: false })
        }
      })
    })
  }
  static async getListProduct(data) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: '/Product/user/getList',
        data: data
      }).then((result = {}) => {
        const { statusCode, data } = result
        if (statusCode === 200) {
          return resolve({ isSuccess: true, data })
        } else {
          return resolve({ isSuccess: false })
        }
      })
    })
  }
  static async getInsuranceByVehicle(data) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: '/Product/user/getInsuranceByVehicle',
        data: data
      }).then((result = {}) => {
        const { statusCode, data } = result
        if (statusCode === 200) {
          return resolve({ isSuccess: true, data })
        } else {
          return resolve({ isSuccess: false })
        }
      })
    })
  }
  static async createOrderPaymentInsurtance(data) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: '/Order/user/createOrderPaymentInsurtanceMotobike',
        data: data,
        headers: {
          'x-app-name': process.env.REACT_APP_THEME_NAME || 'TTDK'
        }
      }).then((result = {}) => {
        const { statusCode, data } = result
        if (statusCode === 200) {
          return resolve(result)
        } else {
          return resolve(result)
        }
      })
    })
  }

  static async createOrderPaymentInsurtanceTNDSOto(data) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: '/Order/user/createOrderPaymentInsurtanceTNDSOto',
        data: data,
        headers: {
          'x-app-name': process.env.REACT_APP_THEME_NAME || 'TTDK'
        }
      }).then((result = {}) => {
        const { statusCode, data } = result
        if (statusCode === 200) {
          return resolve(result)
        } else {
          return resolve(result)
        }
      })
    })
  }

  static async getOrderDetail(data) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: '/Order/user/getOrderDetail',
        data: data
      }).then((result = {}) => {
        const { statusCode, data } = result
        if (statusCode === 200) {
          return resolve(result)
        } else {
          return resolve(result)
        }
      })
    })
  }
  static async getAppUserInsuranceDetail(data, token) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: '/AppUserInsurance/user/getDetail',
        data: data,
        token
      }).then((result = {}) => {
        const { statusCode, data } = result
        if (statusCode === 200) {
          return resolve(result)
        } else {
          return resolve(result)
        }
      })
    })
  }
  static async getVehicleInfoByToken(data) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: '/AppUserVehicle/user/getList',
        data: data
      }).then((result = {}) => {
        const { statusCode, data } = result
        if (statusCode === 200) {
          return resolve(result)
        } else {
          return resolve(result)
        }
      })
    })
  }

  static async registerUserByPhone(data) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: '/AppUsers/registerUserByPhone',
        data: data
      }).then((result = {}) => {
        const { statusCode, data } = result
        if (statusCode === 200) {
          return resolve(result)
        } else {
          return resolve(result)
        }
      })
    })
  }

  static async loginUserByPhone(data) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: '/AppUsers/loginUserByPhone',
        data: data,
        isUsingToken: false
      }).then((result = {}) => {
        const { statusCode, data } = result
        if (statusCode === 200) {
          // Lưu token vào localStorage nếu cần
          if (data?.token) {
            window.localStorage.setItem('BHXM_token', data.token)
          }
          return resolve(result)
        } else {
          return resolve(result)
        }
      })
    })
  }

  static async getListVehicleByAppUserId(appUserId, token, limit) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: '/AppUserVehicle/user/getList',
        data: { filter: { appUserId }, limit },
        token
      }).then((result = {}) => {
        const { statusCode, data } = result
        if (statusCode === 200) {
          return resolve(result)
        } else {
          return resolve(result)
        }
      })
    })
  }

  static async deleteVehicle(vehicleId, token) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: '/AppUserVehicle/user/deleteVehicle',
        data: { id: vehicleId },
        token
      }).then((result = {}) => {
        const { statusCode, data } = result
        if (statusCode === 200) {
          return resolve(result)
        } else {
          return resolve(result)
        }
      })
    })
  }

  static async registerVehicle(data, token) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: '/AppUserVehicle/user/registerVehicle',
        data: data,
        token
      }).then((result = {}) => {
        const { statusCode, data } = result
        if (statusCode === 200) {
          return resolve(result)
        } else {
          return resolve(result)
        }
      })
    })
  }

  static async userCheckCriminal(data = {}, token = undefined) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: '/CustomerCriminalRecord/user/userCheckCriminalFromVr',
        data,
        token
      }).then((result = {}) => {
        return resolve(result)
      })
    })
  }

  static async getCrimeRecords(data = {}, token = undefined) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: '/CustomerCriminalRecord/user/getCrimeRecords',
        data,
        token
      }).then((result = {}) => {
        return resolve(result)
      })
    })
  }

  static async getHomePageConfigPartner(data = {}) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: '/HomePageConfig/partner/getHomePageConfig',
        data,
        token: false
      }).then((result = {}) => {
        return resolve(result)
      })
    })
  }

  static async getStationBannersPartner(data = {}) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: '/SystemPromoBanners/partner/getStationBanners',
        data,
        token: false
      }).then((result = {}) => {
        return resolve(result)
      })
    })
  }

  static async createOrderAutoNoty(data) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: '/PartnerAPI/Order/user/createOrderAutoNoty',
        data: data,
        headers: {
          'x-app-name': process.env.REACT_APP_THEME_NAME || 'TTDK'
        },
        token: false
      }).then((result = {}) => {
        const { statusCode, data } = result
        if (statusCode === 200) {
          return resolve(result)
        } else {
          return resolve(result)
        }
      })
    })
  }

  static async createPayment(data) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: '/PartnerAPI/CustomerSchedule/user/createPayment',
        data: data,
        headers: {
          'x-app-name': process.env.REACT_APP_THEME_NAME || 'TTDK'
        },
        token: false
      }).then((result = {}) => {
        const { statusCode, data } = result
        if (statusCode === 200) {
          return resolve(result)
        } else {
          return resolve(result)
        }
      })
    })
  }

  static async userUpdateNotifyPackage(data, token) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: '/AppUserVehicleNotifyInfo/user/updateById',
        data: data,
        token
      }).then((result = {}) => {
        return resolve(result)
      })
    })
  }

  static async viettelMoneyAPIInitializeLink(data) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: '/ViettelMoneyAPI/initializeLink',
        data: data,
        headers: {
          'x-app-name': process.env.REACT_APP_THEME_NAME || 'TTDK'
        }
      }).then((result = {}) => {
        const { statusCode, data } = result
        if (statusCode === 200) {
          return resolve(result)
        } else {
          return resolve(result)
        }
      })
    })
  }

  static async viettelMoneyAPIPayment(data) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: '/ViettelMoneyAPI/payment',
        data: data,
        headers: {
          'x-app-name': process.env.REACT_APP_THEME_NAME || 'TTDK'
        }
      }).then((result = {}) => {
        return resolve(result)
      })
    })
  }
}
